window.trans = {
	global: {
		success: "Success",
		error: "Error",
		required: "This field is required",
		loading: "Please wait while we load results",
		notifications_empty: "You have 0 notifications"
	},
	passwords: {
		password: "Passwords must be at least six characters and match the confirmation.",
		reset: "Your password has been reset!",
		sent: "We have e-mailed your password reset link!",
		token: "This password reset token is invalid.",
		user: "We can't find a user with that e-mail address."
	},
	page_search: { no_results: "Search returned no results", f_search: "Search" },
	auth: {
		failed: "These credentials do not match our records.",
		throttle: "Too many login attempts. Please try again in :seconds seconds.",
		login_failed: "Please check your username / email / mobile and or password are correct.",
		no_results: "No results found for search term.",
		a_link_to_pictures: "Student login",
		a_back_to_reset: "Back to Login",
		a_link_to_reset_password: "Forgot your password?",
		b_login: "Login",
		b_token: "Next step",
		b_reset: "Reset password",
		b_search: "Search",
		b_searching: "Searching...",
		b_join: "Create account",
		d_or: "or",
		p_leave_blank: "This will be the email address you use to login to your Wonde account.",
		h_find_school: "Login to Wonde",
		h_signup: "Sign-up to Wonde",
		h_select_dob: "Please select your date of birth",
		h_invite_code: "Please enter your invite code",
		h_enter_details: "Enter your email address",
		h_no_school: "No school found",
		a_back_to_search: "Go back to search?",
		h_right_order: "Enter your password by choosing your pictures in the right order:",
		l_username: "Please enter your email or mobile number",
		l_reset_email: "Please enter your email address",
		l_date_of_birth: "Date of birth",
		l_post_code: "Postcode",
		l_reset_mobile: "Your mobile number",
		l_pin: "Please enter the number on the top left of your badge.",
		l_reset_pincode: "Reset pin code",
		l_email: "Email address",
		"l_sign-up_email": "Email address",
		"l_sign-up_mobile": "Mobile number",
		l_password: "Password",
		l_password_picture: "Please enter your emoji password",
		l_password_confirm: "Password confirmation",
		l_forename: "Forename",
		l_surname: "Surname",
		l_search: "Please enter school number, name or postcode",
		l_select: "Please select your school from the results:",
		l_case_sensitive: "The invite code is case sensitive."
	},
	page_app_provision: {
		l_must_match: "Students must match",
		l_rules: "of the following statements:",
		l_new_rule: "New Rule:",
		l_selector: "Select type",
		b_add_rule: "Add Rule",
		s_value: "Select value",
		popup_title: "Save changes",
		popup_cancel: "Cancel",
		popup_confirm: "Confirm",
		popup_question: "Please give a name to this set of rules to make it easier to find in the future."
	},
	settings: {
		counting_users: "Counting users...",
		settings_title: "Your School",
		account_management_title: "Account Management",
		user_provisioning_invite_title: "Send Invitations",
		user_provisioning: "Account Management",
		user_provisioning_download_title: "Download Credentials",
		application_provisioning: "Application Management",
		user_provisioning_description: "Invite school school staff, students and parents to create their Wonde accounts and manage existing accounts.",
		application_provisioning_description: "Setup provisioning rules, manage access to applications and manage application settings.",
		user_provisioning_invite_staff: "Invite School Staff",
		user_provisioning_invite: "Invite school staff and parents",
		user_provisioning_invite_description: "Invite staff and parents to create their Wonde accounts. ",
		user_provisioning_manage: "Manage Users",
		user_provisioning_manage_description: "Reset passwords, deactivate accounts and manage the user directory.",
		user_provisioning_download: "Student Passwords",
		user_provisioning_download_description: "Download your student's emoji passwords and magic badges.",
		user_provisioning_settings: "Account Settings",
		user_provisioning_settings_description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cumque, ex fugit iusto minus mollitia nobis quas",
		user_provisioning_manage_title: "Manage Accounts",
		user_provisioning_manage_search: "Search",
		user_provisioning_show_disable: "Active User",
		user_provisioning_show_sent_invite: "Invite successfully sent",
		user_provisioning_show_sent_invite_failed: "Failed to send invite",
		user_account_loading: "Loading Account",
		settings_updated: "Settings updated successfully.",
		no_invites_to_send: "Yay, all up to date, nothing to send."
	},
	store: {
		popular_title: "Featured Apps",
		popular_title_preview: "Preview Mode",
		popular_subtitle: "Here are some of our features apps, click and take a look",
		index_loading: "Loading...",
		loading: "Loading..."
	},
	pagination: { previous: "&laquo; Previous", next: "Next &raquo;" },
	page_dashboard: {
		m_loading: "Just one moment while we load your applications.",
		m_loading_accounts: "Just one moment while we load your accounts.",
		h_discover: "Discover other applications...",
		p_discover: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus, blanditiis consequuntur dignissimos ducimus excepturi!"
	},
	header: {
		b_notifications: "Notifications",
		b_classes: "Classes",
		b_settings: "Settings",
		b_store: "Discover",
		b_sso_opt_in: "Single Sign-On",
		b_apps: "My Apps",
		b_accounts: "Children"
	},
	notifications: {
		h_panel: "Notifications",
		a_notification_settings: "Notification preferences",
		a_clear_notifications: "Clear notifications",
		notifications_cleared: "Notifications cleared.",
		empty: "You have 0 notifications"
	},
	page_my_applications: {
		header: "Application Settings",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Nam ex quasi inventore quam, dolorum cumque tempora consequatur veritatis, error nisi excepturi explicabo dolores accusamus, numquam eius ad repudiandae natus doloribus.",
		empty: "You have no applications authorised to access your account.",
		m_loading: "Loading your settings"
	},
	validation: {
		accepted: "The :attribute must be accepted.",
		active_url: "The :attribute is not a valid URL.",
		after: "The :attribute must be a date after :date.",
		after_or_equal: "The :attribute must be a date after or equal to :date.",
		alpha: "The :attribute may only contain letters.",
		alpha_dash: "The :attribute may only contain letters, numbers, and dashes.",
		alpha_num: "The :attribute may only contain letters and numbers.",
		array: "The :attribute must be an array.",
		before: "The :attribute must be a date before :date.",
		before_or_equal: "The :attribute must be a date before or equal to :date.",
		between: {
			numeric: "The :attribute must be between :min and :max.",
			file: "The :attribute must be between :min and :max kilobytes.",
			string: "The :attribute must be between :min and :max characters.",
			array: "The :attribute must have between :min and :max items."
		},
		boolean: "The :attribute field must be true or false.",
		confirmed: "The :attribute confirmation does not match.",
		date: "The :attribute is not a valid date.",
		date_format: "The :attribute does not match the format :format.",
		different: "The :attribute and :other must be different.",
		digits: "The :attribute must be :digits digits.",
		digits_between: "The :attribute must be between :min and :max digits.",
		dimensions: "The :attribute has invalid image dimensions.",
		distinct: "The :attribute field has a duplicate value.",
		email: "The :attribute must be a valid email address.",
		exists: "The selected :attribute is invalid.",
		file: "The :attribute must be a file.",
		filled: "The :attribute field must have a value.",
		image: "The :attribute must be an image.",
		in: "The selected :attribute is invalid.",
		in_array: "The :attribute field does not exist in :other.",
		integer: "The :attribute must be an integer.",
		ip: "The :attribute must be a valid IP address.",
		ipv4: "The :attribute must be a valid IPv4 address.",
		ipv6: "The :attribute must be a valid IPv6 address.",
		json: "The :attribute must be a valid JSON string.",
		max: {
			numeric: "The :attribute may not be greater than :max.",
			file: "The :attribute may not be greater than :max kilobytes.",
			string: "The :attribute may not be greater than :max characters.",
			array: "The :attribute may not have more than :max items."
		},
		mimes: "The :attribute must be a file of type: :values.",
		mimetypes: "The :attribute must be a file of type: :values.",
		min: {
			numeric: "The :attribute must be at least :min.",
			file: "The :attribute must be at least :min kilobytes.",
			string: "The :attribute must be at least :min characters.",
			array: "The :attribute must have at least :min items."
		},
		not_in: "The selected :attribute is invalid.",
		numeric: "The :attribute must be a number.",
		present: "The :attribute field must be present.",
		regex: "The :attribute format is invalid.",
		required: "The :attribute field is required.",
		required_if: "The :attribute field is required when :other is :value.",
		required_unless: "The :attribute field is required unless :other is in :values.",
		required_with: "The :attribute field is required when :values is present.",
		required_with_all: "The :attribute field is required when :values is present.",
		required_without: "The :attribute field is required when :values is not present.",
		required_without_all: "The :attribute field is required when :values are not present.",
		same: "The :attribute and :other must match.",
		size: {
			numeric: "The :attribute must be :size.",
			file: "The :attribute must be :size kilobytes.",
			string: "The :attribute must be :size characters.",
			array: "The :attribute must contain :size items."
		},
		string: "The :attribute must be a string.",
		timezone: "The :attribute must be a valid zone.",
		unique: "The :attribute has already been taken.",
		uploaded: "The :attribute failed to upload.",
		url: "The :attribute format is invalid.",
		current_password: "The :attribute is invalid.",
		phone: "The :attribute field contains an invalid number.",
		email_in_use: "There is already an account with this email address.",
		custom: { "attribute-name": { "rule-name": "custom-message" } },
		attributes: []
	},
	page_account: {
		h_account: "Your account",
		p_account: "Update the name and email address that you use for Wonde.",
		l_first: "First name",
		l_last: "Last name",
		l_email: "Email address",
		l_password: "Password",
		l_current_password: "Current password",
		l_password_confirm: "Password confirm",
		h_password: "Your password",
		p_password:
			"You can change your password here. To keep your account secure, it must be at least 5 characters long and contain at least one letter, number and symbol.",
		p_password_picture: "This is your Emoji password. Keep it safe and never show it to your classmates. Passwords keep the data we store online secure.",
		v_password_update: "Password updated successfully",
		v_password_update_error: "Failed to update password",
		v_account_update: "Updated account successfully",
		v_account_update_error: "Failed to update account",
		v_length_5: "Length should be at least 5",
		l_mobile: "Mobile",
		h_notifications: "Notifications",
		p_notifications:
			"Wonde will send you a notification every time something interesting happens on your account. You can change how this works with the settings below.",
		l_notifications_active: "Allow Wonde to send you notifications",
		l_notifications_via_email: "Send notifications via email",
		l_notifications_via_mobile: "Send notifications via text message"
	},
	page_application: {
		m_loading: "Loading application details, please wait.",
		h_permissions: "App Permissions",
		p_permissions: "This application has requested the following permissions to access your school data (click on a section to expand):",
		p_permissions_approved: "This application has the following permissions to access your school data (click on a section to expand):",
		b_revoke: "This application has access to your school data, click here to revoke access to this application",
		b_approve: "Approve access",
		b_install_instant: "Launch App",
		b_install: "Enquire",
		b_decline: "Decline access",
		v_approve_access: "Access was approved successfully.",
		v_revoke_access: "Access was revoked successfully.",
		v_scopes_changed: "Application permissions updated successfully.",
		c_confirm: "Are you sure to do this? Performing this action might prevent the application from working as expected.",
		c_success: "Application's access revoked.",
		c_cancel: "Action cancelled",
		c_button: "Revoke access",
		c_button_c: "Cancel",
		h_about: "About this Application",
		h_product_reviews: "School Reviews",
		l_categories: "Categories",
		l_audience: "Audiences",
		l_homepage: "Homepage",
		l_price: "Price",
		h_product_ratings: "Ratings",
		h_product_details: "Product Details"
	},
	page_classes: {
		loading: "Loading classes",
		loading_students: "Loading students",
		class: "Class",
		classes: "Classes",
		select_groups: "Select Group",
		registration: "Registration",
		reset_code_title: "Reset Code",
		generating_pin: "Generating reset pin code.",
		b_profile: "Profile",
		b_reset: "Reset",
		b_password: "Password",
		empty: "No classes or registration groups available.",
		empty_students: "No students available."
	}
};



// WEBPACK FOOTER //
// ./src/lang.js